module.exports = INFOBOX_AT_TOP;